import React from "react";
import { convertToRGBAString } from "utils/helperFunctions";
import propTypes from "prop-types";
import { useSelector } from "react-redux";

const DynamicButton = ({ button, handleClick, className }) => {
  const { buttonsDisable } = useSelector((state) => state);
  
  return (
    button.enabled && (
      <button
        className={`nav-button ${className} ${
          buttonsDisable && "button--disabled"
        }`}
        onClick={handleClick}
        style={{
          backgroundColor: convertToRGBAString(button.backgroundColor),
          color: convertToRGBAString(button.color),
          // boxShadow:
          //   `4px 10px 20px 0px ` +
          //   convertToRGBAString([...button.backgroundColor.slice(0, -1), 0.25]),
        }}
        disabled={buttonsDisable}
      >
        {button.title}
      </button>
    )
  );
};

DynamicButton.propTypes = {
  button: propTypes.shape({
    enabled: propTypes.bool.isRequired,
    backgroundColor: propTypes.array.isRequired,
    color: propTypes.array.isRequired,
    title: propTypes.string.isRequired,
  }).isRequired,
  handleClick: propTypes.func,
};

DynamicButton.defautProps = {
  handleClick: () => {
    console.log("Button default click");
  },
};

export default DynamicButton;
